<link rel="stylesheet" href="https://unpkg.com/swiper/css/swiper.css">
<link rel="stylesheet" href="https://unpkg.com/swiper/css/swiper.min.css">

<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0px">
    <div fxFlex  fxHide fxShow.gt-md fxFlexAlign="center">
        <div class="videos">
            <div  class="swiper-container " [swiper]="videosConfig" >
                <div class="swiper-wrapper " >
                    <div class="swiper-slide" >
                        <youtube-player videoId="iZAA7oKXE14" class="youtube-video" [width]="400" [height]="225"></youtube-player>
                    </div>
                    <div class="swiper-slide" >
                        <youtube-player videoId="OnscxIOQu2k" class="youtube-video" [width]="400" [height]="225"></youtube-player>
                    </div>
                </div>
            </div>
               
                <div class="videos-swiper-scrollbar"></div>
                <div class="videos-swiper-pagination"></div>
               
                <div class="videos-swiper-button-prev"></div>
                <div class="videos-swiper-button-next"></div>
              
        </div>
    </div>
</div>

